export { Initialization as ApplicationInsights, Telemetry } from "./Initialization";
export { ApplicationInsightsContainer } from "./ApplicationInsightsContainer";
// Re-exports
export { AppInsightsCore, LoggingSeverity, _InternalMessageId } from "@microsoft/applicationinsights-core-js";
export { Util, SeverityLevel, Event, Exception, Metric, PageView, PageViewPerformance, RemoteDependencyData, Trace, DistributedTracingModes } from "@microsoft/applicationinsights-common";
export { Sender } from "@microsoft/applicationinsights-channel-js";
export { ApplicationInsights as ApplicationAnalytics } from "@microsoft/applicationinsights-analytics-js";
export { PropertiesPlugin } from "@microsoft/applicationinsights-properties-js";
export { AjaxPlugin as DependenciesPlugin } from "@microsoft/applicationinsights-dependencies-js";
//# sourceMappingURL=applicationinsights-web.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-web/dist-esm/applicationinsights-web.js
// module id = 612
// module chunks = 42